<template>
  <h3 v-if="getAppliedSalesTax" class="text-body-1"
    >Sales Tax ({{ getTheCart.sales_tax }}%) :
    {{ getTheCart.sales_tax_formatted }}</h3
  >
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'CartSalesTax',
  data() {
    return {}
  },
  computed: {
    ...mapGetters('cart', ['getTheCart', 'getAppliedSalesTax']),
  },
}
</script>
